import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { trans, getPagePath, getResourcePath } from '@spotahome/soyuz/client';

// styles
import './City.scss';

const CityListItem = ({ href, transKey, cityName }) => (
  <li className="city-count__list-item">
    <a href={href}>{trans(transKey, { city: cityName })}</a>
  </li>
);

CityListItem.propTypes = {
  href: PropTypes.string.isRequired,
  transKey: PropTypes.string.isRequired,
  cityName: PropTypes.string.isRequired
};

const City = props => {
  const { id, country } = props;
  const cityName = trans(`city.${id}`);
  const cityLanguageId = trans(`city.seo.${id}`);
  const path = getPagePath('realestate.search', {
    params: { city: id }
  });
  const seoPath = getPagePath('seo.cityhub', {
    params: { city: cityLanguageId }
  });

  return (
    <div className={`city ga-home-city-list-${id}`}>
      <a href={path}>
        <LazyLoad height={200} offset={[150, 150]} once>
          <figure className="city-image">
            <img
              src={getResourcePath(`/images/home/city-list/${id}.jpg`)}
              alt={cityName}
            />
          </figure>
        </LazyLoad>
        <div className="city-info">
          <span className="city-info-name">{cityName}</span>
          <span className="city-info-country">
            {trans(`country.${country}`)}
          </span>
        </div>
      </a>
      <div className="city-count">
        <ul className="city-count__list">
          <CityListItem
            href={seoPath}
            cityName={cityName}
            transKey="city.for-rent"
          />
          <CityListItem
            href={`${path}/for-rent:apartments`}
            cityName={cityName}
            transKey="city.for-rent.apartments"
          />
          <CityListItem
            href={`${path}/for-rent:studios`}
            cityName={cityName}
            transKey="city.for-rent.studios"
          />
          <CityListItem
            href={`${path}/for-rent:rooms`}
            cityName={cityName}
            transKey="city.for-rent.rooms"
          />
          <CityListItem
            href={`${path}/for-rent:residences`}
            cityName={cityName}
            transKey="city.for-rent.residences"
          />
        </ul>
      </div>
    </div>
  );
};
City.defaultProps = {
  country: ''
};
City.propTypes = {
  id: PropTypes.string.isRequired,
  country: PropTypes.string
};
export default City;
